/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown>, count: NonNullable<unknown> }} Agenda_Journey_Pill_ShortInputs */



/**
* | output |
* | --- |
* | "Journey {position}/{count}" |
*
* @param {Agenda_Journey_Pill_ShortInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_journey_pill_short = /** @type {((inputs: Agenda_Journey_Pill_ShortInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Journey_Pill_ShortInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Traject ${i?.position}/${i?.count}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Parcours ${i?.position}/${i?.count}`)
	return /** @type {LocalizedString} */ (`Journey ${i?.position}/${i?.count}`)
});